<template>
	<main>
		<!-- @TODO: refactor into loop -->
		<section class="setting font-sans">
			<label>
				<input type="checkbox" id="checkbox" v-model="showExtraData">
				Show Extra Data
			</label>
		</section>

		<section class="setting font-sans">
			<label>
				<input type="checkbox" id="checkbox" v-model="showUnplayableCharacters">
				Show Unplayable Characters
			</label>
		</section>

	</main>
</template>

<script>
	export default {
		name: 'Settings',
		computed: {
			showExtraData: {
				get()
				{
					return this.$store.getters.getShowExtraData;
				},
				set( val )
				{
					this.$store.commit( 'setShowExtraData', val );
				}
			},
			showUnplayableCharacters: {
				get()
				{
					return this.$store.getters.getShowUnplayableCharacters;
				},
				set( val )
				{
					this.$store.commit( 'setShowUnplayableCharacters', val );
				}
			},

		},
	}
</script>

<style lang="scss" scoped>
	main {
		max-width: 600px;
		margin: 0 auto;
		background-color: #111;
		padding: 20px;
	}

	.setting + .setting {
		margin-top: 20px;
	}

	label {
		font-size: 1.4rem;
		user-select: none;
	}

	input[type="checkbox"] {
		transform: scale(2);
		margin-right: 10px;
	}
</style>